import { useState } from "react";
import { animated, useSpring } from "react-spring";
import { colors } from "../../../constants/constants";
import { useWindowSize } from "../../../hooks/useWindowSize";

const MenuColumnNumber = ({ number, active }) => {
  const [widthExtended, setWidthExtended] = useState(false);
  const { mobileHorizontal, tabletHorizontal }: any = { ...useWindowSize() };

  const { height } = useSpring({
    from: { height: "0px" },
    to: {
      height: widthExtended
        ? mobileHorizontal || tabletHorizontal
          ? "32px"
          : "48px"
        : "0px",
    },
    config: {
      tension: 280,
      friction: 120,
      mass: 10,
    },
  });
  const { numberBarColor } = useSpring({
    from: { numberBarColor: colors.purple4 },
    to: { numberBarColor: active ? colors.pink : colors.purple4 },
    config: {
      tension: 280,
      friction: 120,
      mass: 10,
    },
  });
  const { width } = useSpring({
    from: { width: "0em" },
    to: { width: active ? "2rem" : "1em" },
    config: { duration: 500 },
    onRest: () => {
      setWidthExtended(true);
    },
  });

  return (
    <div
      style={{
        height: "48px",
        width: "100%",
        paddingTop: "1.5rem",
        paddingBottom: "1.5rem",
      }}
    >
      <animated.div
        style={{
          // fontSize: "0.5em",
          letterSpacing: "0.4em",
          height,
          overflowY: "hidden",
          fontSize: "0.75rem",
          lineHeight: "1rem",
          fontWeight: "600",
        }}
      >
        {number}
      </animated.div>
      <animated.div
        style={{
          width,
          height: "0.25rem",
          backgroundColor: numberBarColor,
        }}
      />
    </div>
  );
};

export default MenuColumnNumber;
